import { useState } from "react";
import { mockPayoutHistory, mockResellerStats, mockResellerUser } from "@/mocks/reseller";

const PayoutPanel = () => {
  const [showRequest, setShowRequest] = useState(false);

  return (
    <div className="space-y-4">
      {/* PayPal Payout Card */}
      <div className="bg-gradient-to-br from-[#003087] to-[#009cde] rounded-xl p-5 text-white">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg">
            <i className="ri-paypal-line text-white text-xl"></i>
          </div>
          <div>
            <div className="font-bold text-sm">PayPal Payout</div>
            <div className="text-white/70 text-xs">{mockResellerUser.paypalEmail}</div>
          </div>
        </div>
        <div className="mb-4">
          <div className="text-white/70 text-xs mb-1">Pending Commission</div>
          <div className="text-3xl font-extrabold">${mockResellerStats.pendingPayout.toLocaleString()}</div>
          <div className="text-white/60 text-xs mt-1">Next auto-payout: May 1, 2024</div>
        </div>
        <button
          onClick={() => setShowRequest(true)}
          className="w-full bg-white text-[#003087] font-bold text-sm py-2.5 rounded-lg hover:bg-white/90 transition-colors cursor-pointer whitespace-nowrap"
        >
          Request Early Payout
        </button>
      </div>

      {/* Total Paid Out */}
      <div className="bg-white rounded-xl border border-gray-100 p-5">
        <div className="flex items-center justify-between mb-3">
          <span className="text-xs text-gray-500 font-semibold">Total Paid Out</span>
          <span className="text-lg font-extrabold text-green-600">${mockResellerStats.paidOut.toLocaleString()}</span>
        </div>
        <div className="w-full bg-gray-100 rounded-full h-2">
          <div
            className="bg-green-500 h-2 rounded-full"
            style={{ width: `${(mockResellerStats.paidOut / mockResellerStats.totalCommission) * 100}%` }}
          ></div>
        </div>
        <div className="text-[10px] text-gray-400 mt-1">
          {Math.round((mockResellerStats.paidOut / mockResellerStats.totalCommission) * 100)}% of total commission paid
        </div>
      </div>

      {/* Payout History */}
      <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
        <div className="px-5 py-4 border-b border-gray-100">
          <h3 className="font-bold text-gray-900 text-sm">Payout History</h3>
        </div>
        <div className="divide-y divide-gray-50">
          {mockPayoutHistory.map((p) => (
            <div key={p.id} className="px-5 py-3 flex items-center justify-between">
              <div>
                <div className="text-xs font-semibold text-gray-900">{p.period}</div>
                <div className="text-[10px] text-gray-400">{p.date} · {p.method}</div>
              </div>
              <div className="text-right">
                <div className="text-sm font-bold text-gray-900">${p.amount.toLocaleString()}</div>
                <span className="text-[10px] font-semibold text-green-600 bg-green-50 px-2 py-0.5 rounded-full">
                  {p.status}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Early Payout Modal */}
      {showRequest && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl p-6 max-w-sm w-full">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center bg-[#003087]/10 rounded-lg">
                <i className="ri-paypal-line text-[#003087] text-xl"></i>
              </div>
              <div>
                <div className="font-bold text-gray-900">Request Early Payout</div>
                <div className="text-xs text-gray-400">Minimum $100 required</div>
              </div>
            </div>
            <div className="bg-gray-50 rounded-lg p-4 mb-4">
              <div className="flex justify-between text-sm mb-2">
                <span className="text-gray-500">Available Balance</span>
                <span className="font-bold text-gray-900">${mockResellerStats.pendingPayout.toLocaleString()}</span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-gray-500">PayPal Account</span>
                <span className="font-semibold text-gray-700 text-xs">{mockResellerUser.paypalEmail}</span>
              </div>
            </div>
            <div className="flex gap-3">
              <button
                onClick={() => setShowRequest(false)}
                className="flex-1 border border-gray-200 text-gray-600 py-2.5 rounded-lg text-sm font-semibold hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                Cancel
              </button>
              <button
                onClick={() => setShowRequest(false)}
                className="flex-1 bg-[#003087] text-white py-2.5 rounded-lg text-sm font-bold hover:bg-[#002070] transition-colors cursor-pointer whitespace-nowrap"
              >
                Confirm Payout
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PayoutPanel;
